import styled from "styled-components";
import { Card, Button, TreeSelect, Input } from "antd";

export const Title = styled.h1`
	font-size: 40px;
	color: black;
`;
export const TitleCard = styled.h2`
	font-size: 26px;
	font-weight: 300;
	color: black;
`;
export const TitleCardVisit = styled.h2`
	font-size: 22px;
	font-weight: 300;
	color: rgb(200, 96, 36);
`;

export const TableKpi = styled.table`
	overflow: hidden;
	width: 100%;
	&& {
		td,
		th {
			padding: 8px;
			outline: 0;
			width: 20%;
			word-break: break-word;
		}
	}
`;

export const TitleStep = styled.p`
	font-size: 20px;
	color: #ed8b00;
	margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "20px")};
	padding-top: 10px;
	padding-bottom: ${props =>
		props.paddingBottom ? props.paddingBottom : "10px"};
	text-transform: uppercase;
	text-align: center;
	border-bottom: ${props =>
		props.borderBottom ? props.borderBottom : "1px solid rgb(200, 200, 200);"};
`;
export const SubTitleStep = styled.p`
	font-size: 10px;
	padding-bottom: 5px;
	text-align: center;
	font-style: italic;
	border-bottom: 1px solid rgb(200, 200, 200);
`;

export const SubTitle = styled.p`
	font-size: ${props => (props.size ? props.size : "16px")};
	color: ${props => (props.color ? props.color : "black")};
	padding-left: ${props => (props.paddingLeft ? props.paddingLeft : "20px")};
	margin-top: ${props => (props.marginTop ? props.marginTop : "40px")};
	margin-bottom: ${props => (props.marginBottom ? props.marginBottom : "20px")};
`;

export const Content = styled.div`
	padding: 5px;
	margin-top: 40px;
`;

export const SpanLocation = styled.span`
	text-decoration: ${props => (props.decoration ? props.decoration : "none")};
	font-style: ${props => (props.fontStyle ? props.fontStyle : "normal")};
	font-size: 15px;
`;

export const ContentCard = styled.div`
	margin-top: ${props => (props.marginTop ? props.marginTop : "5px")};
	padding-left: ${props => (props.paddinSumm ? props.paddinSumm : "20px")};
`;

export const StepCard = styled(Card)`
	&& {
		margin: ${props => (props.margin ? props.margin : "40px auto 0 auto")};
		width: ${props => (props.width ? props.width : null)};
		max-width: ${props => (props.maxWidth ? props.maxWidth : null)};
		border-top: 4px solid #ed8b00 !important;
		height: ${props => (props.maxHeight ? props.maxHeight : null)};
		text-align: ${props => (props.align ? props.align : "left")};
		box-shadow: 3px 3px 5px 0 rgba(170, 170, 170, 0.5);
	}
`;

export const StepDiv = styled.div`
	margin: ${props =>
		props.margin ? props.margin : "20px auto 0 auto !important"};
	width: 100%;
	max-width: ${props => (props.maxWidth ? props.maxWidth : "600px")};
	min-height: 300px;
	text-align: ${props => (props.align ? props.align : "left")};
`;
export const StepCardAction = styled.div`
	background-color: transparent !important;
	max-width: 400px;
	margin: auto;
	border-left: none;
	border-right: none;
	border-bottom: none;
	padding: 0px 2% 0px 2%;
`;

export const InfosMetier = styled.div`
	background-color: rgb(245, 245, 245);
	padding: 5px;
	margin-top: 10px;
`;

export const Label = styled.span`
	font-size: 12px;
	font-weight: ${props => props.weight};
`;

export const ContentDiv = styled.div`
	margin-top: 20px;
	margin-bottom: 40px;
`;

export const ContentMap = styled.div`
	margin-top: 10px;
`;

export const Divider = styled.div`
	display: block;
	height: 1px;
	width: 100%;
	margin: 10px 0;
	background-color: rgb(200, 200, 200);
`;

export const InputField = styled.input`
	display: inline-block;
	padding: 8px 20px;
	margin: 8px 0;
	border: 1px solid #ccc;
	border-radius: 4px;
	display: inline-block;
	box-sizing: border-box;
`;

export const InputFieldAnt = styled(Input)`
	width: 100%;
	padding: 2px;
	margin: 2px 0;
	display: inline-block;
	border: 1px solid #ccc;
	border-radius: 4px;
	box-sizing: border-box;
`;

export const InputSubmitOutline = styled.input`
	width: 100%;
	color: #ed8b00;
	background-color: white;
	padding: 14px 10px;
	margin: 20px 0 8px 0;
	border: 1px solid #ed8b00;
	border-radius: 4px;
	cursor: pointer;
	&:hover {
		background-color: #ed8b00;
		color: white;
	}
`;
export const InputSubmit = styled.input`
	background-color: #ed8b00;
	color: white;
	padding: 10px 25px;
	border: 1px solid #ed8b00;
	border-radius: 4px;
	margin: ${props => (props.margin ? props.margin : "auto 0 0 auto")};
	cursor: pointer;
	&:hover {
		background-color: #fba123;
		color: white;
	}
	z-index: 1;
`;
export const TreeSelectStyled = styled(TreeSelect)`
	&& {
		// background-color: #ED8B00;
		color: black;
	}
`;
export const ButtonStyled = styled(Button)`
	&& {
		background-color: #ed8b00;
		color: white;
		font-weight: 400;
		font-size: 16px;
	}
`;
export const ButtonStyled2 = styled(Button)`
	&& {
		background-color: #ed8b00;
		color: white;
		font-weight: 400;
		font-size: 16px;
	}
`;

export const InputFile = styled.input`
	opacity: 0;
	position: relative;
	width: 0;
	height: 0;
	left: 0;
	&:hover {
		cursor: pointer;
	}
`;

export const InputFileLabel = styled.label`
	position: relative;
	display: inline-block;
	width: auto;
	overflow: hidden;
	margin: 10px 0;
	color: #ed8b00;
	background-color: white;
	padding: 7px 15px;
	border: 1px solid #ed8b00;
	border-radius: 4px;
	&:hover {
		cursor: pointer;
		background-color: #ed8b00;
		color: white;
	}
`;

export const DraggableItem = styled.li`
	padding: 3px 6px;
	border-radius: 5px;
	border: 1px solid #e6e6e6;
	text-align: center;
	margin: 8px 0;
	&:hover {
		cursor: pointer;
	}
`;
export const AgendaCard = styled.div`
	&& {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: ${props => (props.minHeight ? props.minHeight : null)};
		padding: ${props => (props.padding ? props.padding : null)};
		margin: ${props => (props.margin ? props.margin : null)};
		width: ${props => (props.width ? props.width : null)};
		height: ${props => (props.height ? props.height : null)};
		background-color: white;
		border: 1px solid #e8e8e8;
		text-align: ${props => (props.align ? props.align : "left")};
		box-shadow: 3px 3px 5px 0 rgba(170, 170, 170, 0.5);
	}
`;
export const AgendaTitleCard = styled.h3`
	&& {
		color: ${props => (props.color ? props.color : null)};
		text-transform: uppercase;
		font-weight: 600;
		font-size: 16px;
		margin: 0;
		padding: 0;
	}
`;

export const AgendaTitle = styled.h2`
	font-size: 26px;
	color: black;
	margin: 0;
	pardding: 0;
`;



// WEBPACK FOOTER //
// src/components/survey/StyledComponents.js